(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useClickAway;

var _react = require("react");

function useClickAway(props) {
  var isOpen = props.isOpen,
      setOpen = props.setOpen,
      ref = props.ref;
  var fallbackRef = (0, _react.useRef)();
  var dropdownRef = ref || fallbackRef;
  (0, _react.useEffect)(function () {
    if (isOpen) {
      var handleClickAway = function handleClickAway(e) {
        if (!isOrContainsNode(dropdownRef.current, e.target)) {
          setOpen(false);
        }
      };

      var handleKeydown = function handleKeydown(e) {
        if (e.key === "Esc" || e.key === "Escape") {
          setOpen(false);
        }
      };

      document.addEventListener("click", handleClickAway, true);
      document.addEventListener("keydown", handleKeydown);
      return function () {
        document.removeEventListener("click", handleClickAway, true);
        document.removeEventListener("keydown", handleKeydown);
      };
    }
  }, [dropdownRef, isOpen, setOpen]);
  return dropdownRef;
}
/* https://github.com/downshift-js/downshift/blob/046e4abf4468fead3bf3adadb1352279532345ed/src/utils.js#L41-L48*/

/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */


function isOrContainsNode(parent, child) {
  return parent === child || parent.contains && parent.contains(child);
}

},{"react":"react"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDebounce;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Our hook
function useDebounce(value, delay) {
  // State and setters for debounced value
  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      debouncedValue = _useState2[0],
      setDebouncedValue = _useState2[1];

  (0, _react.useEffect)(function () {
    // Set debouncedValue to value (passed in) after the specified delay
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay); // Return a cleanup function that will be called every time ...
    // ... useEffect is re-called. useEffect will only be re-called ...
    // ... if value changes (see the inputs array below).
    // This is how we prevent debouncedValue from changing if value is ...
    // ... changed within the delay period. Timeout gets cleared and restarted.
    // To put it in context, if the user is typing within our app's ...
    // ... search box, we don't want the debouncedValue to update until ...
    // ... they've stopped typing for more than 500ms.

    return function () {
      clearTimeout(handler);
    };
  }, // Only re-call effect if value changes
  // You could also add the "delay" var to inputs array if you ...
  // ... need to be able to change that dynamically.
  [delay, value]);
  return debouncedValue;
}

},{"react":"react"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _useClickAway = _interopRequireDefault(require("../../common/useClickAway.js"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  buttonText: _propTypes.node.isRequired,
  children: _propTypes.node.isRequired
};

var Dropdown = function Dropdown(props) {
  var buttonText = props.buttonText,
      children = props.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var dropdownRef = (0, _react.useRef)();
  (0, _useClickAway.default)({
    isOpen: isOpen,
    setOpen: setOpen,
    ref: dropdownRef
  });
  return _react.default.createElement("div", {
    className: (0, _classnames.default)("dropdown", {
      "is-open": isOpen
    }),
    ref: dropdownRef
  }, _react.default.createElement("button", {
    type: "button",
    className: "dropdown__button",
    onClick: function onClick() {
      return setOpen(function (o) {
        return !o;
      });
    }
  }, buttonText, _react.default.createElement("div", {
    className: "dropdown__arrow"
  }, _react.default.createElement("svg", {
    viewBox: "0 0 14 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "7"
  }, _react.default.createElement("path", {
    d: "M13.667 6.667H.333L7.001 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  })))), _react.default.createElement("div", {
    className: "dropdown__dropdown",
    role: "dialog"
  }, _react.default.createElement(_focusTrapReact.default, {
    active: isOpen // clickOutsideDeactivates prevents FocusTrap from blocking handleClickAway
    ,
    focusTrapOptions: {
      clickOutsideDeactivates: true
    }
  }, _react.default.createElement("div", null, children))));
};

Dropdown.propTypes = propTypes;
var _default = Dropdown;
exports.default = _default;

},{"../../common/useClickAway.js":1,"classnames":"classnames","focus-trap-react":"focus-trap-react","prop-types":"prop-types","react":"react"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _RadioGroup = require("./RadioGroup.jsx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  children: _propTypes.node,
  checked: _propTypes.bool,
  defaultChecked: _propTypes.bool,
  name: _propTypes.string,
  onChange: _propTypes.func,
  value: _propTypes.any
}; // component to use with a RadioGroup

var Radio = function Radio(props) {
  return _react.default.createElement(_RadioGroup.RadioGroupContext.Consumer, null, function () {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var children = props.children,
        value = props.value,
        otherProps = _objectWithoutProperties(props, ["children", "value"]); // get the prop from props or context


    var valueOf = function valueOf(prop) {
      return props[prop] || context[prop];
    }; // make sure defaultValue/selectedValue is on the context first, because
    // `undefined === value` will return false; false is not the same as
    // undefined for defaultChecked/checked


    var defaultChecked = props.defaultChecked || context.defaultValue && context.defaultValue === value;
    var checked = props.checked || context.selectedValue && context.selectedValue === value;

    var _onChange = valueOf("onChange") || function () {};

    return _react.default.createElement("label", {
      className: "radio"
    }, _react.default.createElement("input", _extends({
      type: "radio",
      className: "radio__hidden-input",
      defaultChecked: defaultChecked,
      checked: checked,
      "aria-checked": checked || defaultChecked,
      name: valueOf("name"),
      onChange: function onChange() {
        return _onChange(value);
      },
      value: value
    }, otherProps)), _react.default.createElement("span", {
      className: "radio__custom"
    }), _react.default.createElement("div", {
      className: "radio__label"
    }, children));
  });
};

Radio.propTypes = propTypes;
var _default = Radio;
exports.default = _default;

},{"./RadioGroup.jsx":5,"prop-types":"prop-types","react":"react"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioGroupContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioGroupContext = _react.default.createContext({});

exports.RadioGroupContext = RadioGroupContext;
var propTypes = {
  children: _propTypes.node,
  name: _propTypes.string.isRequired,
  selectedValue: _propTypes.any,
  defaultValue: _propTypes.any,
  onChange: _propTypes.func,
  as: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.object])
};
var defaultProps = {
  as: "div"
};
/**
 * similar API as https://github.com/chenglou/react-radio-group
 */

var RadioGroup = function RadioGroup(props) {
  /* eslint-disable no-unused-vars */
  var name = props.name,
      onChange = props.onChange,
      selectedValue = props.selectedValue,
      children = props.children,
      Component = props.as,
      otherProps = _objectWithoutProperties(props, ["name", "onChange", "selectedValue", "children", "as"]);
  /* eslint-enable no-unused-vars */


  return _react.default.createElement(RadioGroupContext.Provider, {
    value: props
  }, _react.default.createElement(Component, otherProps, children));
};

RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;
var _default = RadioGroup;
exports.default = _default;

},{"prop-types":"prop-types","react":"react"}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  children: _propTypes.node,
  onXClick: _propTypes.func
};
var defaultProps = {
  onXClick: function onXClick() {}
};

var Pill = function Pill(props) {
  var children = props.children,
      onXClick = props.onXClick;
  return _react.default.createElement("div", {
    className: "pill"
  }, children, " ", _react.default.createElement("button", {
    type: "button",
    className: "pill__close",
    onClick: onXClick
  }, _react.default.createElement("svg", {
    viewBox: "0 0 9 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10"
  }, _react.default.createElement("path", {
    stroke: "#FFF",
    fill: "none",
    strokeLinecap: "square",
    d: "M1.054.846l6.6 6.6m-.301-6.8L1.318 7.182"
  }))));
};

Pill.propTypes = propTypes;
Pill.defaultProps = defaultProps;
var _default = Pill;
exports.default = _default;

},{"prop-types":"prop-types","react":"react"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Pill = _interopRequireDefault(require("./Pill.jsx"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown.jsx"));

var _Radio = _interopRequireDefault(require("../Radio/Radio.jsx"));

var _RadioGroup = _interopRequireDefault(require("../Radio/RadioGroup.jsx"));

var R = _interopRequireWildcard(require("ramda"));

var _useApi2 = _interopRequireDefault(require("./useApi.js"));

var _useDebounce = _interopRequireDefault(require("../../common/useDebounce.js"));

var _useClickAway = _interopRequireDefault(require("../../common/useClickAway.js"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ALL_OPTION = {
  id: "all",
  name: "No Selection"
};
var ANY_LOCATION_OPTION = {
  id: "all",
  name: "Any Location Type"
};
var idNamePairShape = (0, _propTypes.shape)({
  id: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired
});
var indicatorShape = (0, _propTypes.shape)({
  name: _propTypes.string.isRequired,
  url: _propTypes.string.isRequired,
  titleMatch: _propTypes.bool,
  notes: (0, _propTypes.arrayOf)(_propTypes.string)
});
var categoryShape = (0, _propTypes.shape)({
  name: _propTypes.string.isRequired,
  indicators: (0, _propTypes.arrayOf)(indicatorShape)
}); // recursive data structure definition
// //https://github.com/facebook/react/issues/5676#issuecomment-287148364

categoryShape.categories = (0, _propTypes.arrayOf)(categoryShape);
var propTypes = {
  demographics: (0, _propTypes.arrayOf)(idNamePairShape).isRequired,
  domains: (0, _propTypes.arrayOf)(idNamePairShape).isRequired,
  initialResults: (0, _propTypes.arrayOf)(_propTypes.object),
  locations: (0, _propTypes.arrayOf)(idNamePairShape).isRequired,
  results: (0, _propTypes.arrayOf)(categoryShape),
  isLandingPage: _propTypes.bool,
  currentDomain: _propTypes.string // initial value for the selectedDomain

};

var Search = function Search(props) {
  var demographics = props.demographics,
      domains = props.domains,
      initialResults = props.initialResults,
      locations = props.locations,
      isLandingPage = props.isLandingPage,
      currentDomain = props.currentDomain;

  var _useState = (0, _react.useState)(currentDomain),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDomain = _useState2[0],
      setDomain = _useState2[1];

  var _useState3 = (0, _react.useState)(_jsCookie.default.get("selectedLocation") || ANY_LOCATION_OPTION.id),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedLocation = _useState4[0],
      setLocation = _useState4[1];

  var _useState5 = (0, _react.useState)(_jsCookie.default.get("selectedDemographic") || ALL_OPTION.id),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedDemographic = _useState6[0],
      setDemographic = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      query = _useState8[0],
      setQuery = _useState8[1]; // what the user is typing


  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isOpen = _useState10[0],
      setOpen = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      hasFocusedOnce = _useState12[0],
      setFocusedOnce = _useState12[1];

  var searchRef = (0, _react.useRef)();
  var debouncedQuery = (0, _useDebounce.default)(query, 500);

  var _useApi = (0, _useApi2.default)({
    text: R.when(R.isEmpty, function () {
      return undefined;
    }, debouncedQuery),
    domain: selectedDomain,
    location: R.when(R.equals(ANY_LOCATION_OPTION.id), function () {
      return undefined;
    }, selectedLocation),
    demographic: R.when(R.equals(ALL_OPTION.id), function () {
      return undefined;
    }, selectedDemographic)
  }, initialResults),
      results = _useApi.results,
      resultsQuery = _useApi.resultsQuery,
      isLoading = _useApi.isLoading,
      error = _useApi.error;

  (0, _react.useEffect)(function () {
    // open the results when we get new results
    // hasFocusedOnce prevents the results from opening on page load
    setOpen(results && hasFocusedOnce);
  }, [results, hasFocusedOnce]);
  (0, _react.useEffect)(function () {
    _jsCookie.default.set("selectedLocation", selectedLocation);
  }, [selectedLocation]);
  (0, _react.useEffect)(function () {
    _jsCookie.default.set("selectedDemographic", selectedDemographic);
  }, [selectedDemographic]);
  (0, _useClickAway.default)({
    isOpen: isOpen,
    setOpen: setOpen,
    ref: searchRef
  });
  var getLabel = R.curry(function (values, id) {
    return R.compose(R.prop("name"), R.find(R.propEq("id", id)))(values);
  });

  var renderFilterItem = function renderFilterItem(item) {
    return _react.default.createElement("div", {
      className: "filter__item",
      key: item.id
    }, _react.default.createElement(_Radio.default, {
      value: item.id
    }, item.name));
  };

  var renderCategory = R.curry(function (level, category) {
    var name = category.name,
        indicators = category.indicators,
        categories = category.categories;
    return _react.default.createElement("div", {
      key: name + level,
      className: (0, _classnames.default)("search-results__category", "search-results__category--level".concat(level), {
        "search-results__category--no-children": R.isNil(categories) || R.isEmpty(categories)
      })
    }, _react.default.createElement("div", {
      className: "search-results__category-name"
    }, name), indicators && indicators.length > 0 && _react.default.createElement("div", {
      className: "search-results__indicators"
    }, indicators.map(renderIndicator)), categories && categories.map(renderCategory(level + 1)));
  });

  var renderIndicator = function renderIndicator(indicator) {
    var name = indicator.name,
        url = indicator.url,
        notes = indicator.notes,
        titleMatch = indicator.titleMatch;
    var queryRegex = RegExp(resultsQuery, "gi");
    var highlighted = R.isEmpty(query) || titleMatch === false ? name : R.compose(R.map(function (word, i) {
      return queryRegex.test(word) ? _react.default.createElement("mark", {
        key: i,
        className: "search-result__highlight"
      }, word) : word;
    }), R.reject(R.isEmpty), // remove empty strings
    R.split("___"), R.replace(queryRegex, function (match) {
      return "___".concat(match, "___");
    }))(name);
    return _react.default.createElement("div", {
      key: url + name,
      className: "search-results__indicator"
    }, _react.default.createElement("a", {
      href: url
    }, highlighted), notes && notes.map(function (note, i) {
      return _react.default.createElement("span", {
        key: i,
        className: "search-results__indicator-note"
      }, note);
    }));
  };

  var openResults = function openResults() {
    setOpen(true);
    setFocusedOnce(true);
  };

  return _react.default.createElement("div", {
    className: "width-header"
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)("search", {
      "search--is-loading": isLoading,
      "search--is-landing-page": isLandingPage
    }),
    ref: searchRef
  }, _react.default.createElement("div", {
    className: "search__domains"
  }, domains.map(function (domain) {
    var name = domain.name,
        id = domain.id;
    return _react.default.createElement("button", {
      type: "button",
      key: id,
      className: (0, _classnames.default)("search__domain", {
        "is-selected": selectedDomain === id
      }),
      style: {
        width: "".concat(1 / domains.length * 100, "%")
      },
      onClick: function onClick() {
        setDomain(domain.id);
        openResults();
      }
    }, name);
  })), _react.default.createElement("div", {
    className: "search__bar"
  }, _react.default.createElement("div", {
    className: "search__box"
  }, _react.default.createElement("input", {
    className: "search__input",
    type: "text",
    placeholder: "Search by Keywords(s)...",
    onFocus: openResults,
    onChange: function onChange(e) {
      return setQuery(e.target.value);
    },
    value: query
  }), _react.default.createElement("div", {
    className: "search__pills"
  }, selectedDomain && _react.default.createElement(_Pill.default, {
    onXClick: function onXClick() {
      return setDomain();
    }
  }, getLabel(domains, selectedDomain)), selectedLocation !== ANY_LOCATION_OPTION.id && _react.default.createElement(_Pill.default, {
    onXClick: function onXClick() {
      return setLocation(ANY_LOCATION_OPTION.id);
    }
  }, getLabel(locations, selectedLocation)), selectedDemographic !== ALL_OPTION.id && _react.default.createElement(_Pill.default, {
    onXClick: function onXClick() {
      return setDemographic(ALL_OPTION.id);
    }
  }, getLabel(demographics, selectedDemographic))), _react.default.createElement("svg", {
    height: "24",
    width: "24",
    className: "search__icon",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M9.516 14.016q1.875 0 3.188-1.313t1.313-3.188-1.313-3.188-3.188-1.313-3.188 1.313-1.313 3.188 1.313 3.188 3.188 1.313zm6 0l4.969 4.969-1.5 1.5-4.969-4.969v-.797l-.281-.281q-1.781 1.547-4.219 1.547-2.719 0-4.617-1.875T3.001 9.516t1.898-4.617 4.617-1.898 4.594 1.898 1.875 4.617q0 2.438-1.547 4.219l.281.281z",
    fill: "currentColor"
  }))), _react.default.createElement("div", {
    className: "search__filter-dropdown"
  }, _react.default.createElement(_Dropdown.default, {
    buttonText: "Filter By Location/Demographics"
  }, _react.default.createElement("div", {
    className: "filter"
  }, _react.default.createElement("div", {
    className: "filter__label"
  }, "Location"), _react.default.createElement(_RadioGroup.default, {
    className: "filter__items",
    name: "location",
    selectedValue: selectedLocation,
    onChange: function onChange(location) {
      setLocation(location);
      openResults();
    }
  }, renderFilterItem(ANY_LOCATION_OPTION), locations.map(renderFilterItem))), _react.default.createElement("div", {
    className: "filter"
  }, _react.default.createElement("div", {
    className: "filter__label"
  }, "Demographics"), _react.default.createElement(_RadioGroup.default, {
    className: "filter__items",
    name: "demographic",
    selectedValue: selectedDemographic,
    onChange: function onChange(demographic) {
      setDemographic(demographic);
      openResults();
    }
  }, renderFilterItem(ALL_OPTION), demographics.map(renderFilterItem)))))), results && (isOpen || isLandingPage) && _react.default.createElement("div", {
    className: "search__results"
  }, error ? _react.default.createElement("div", {
    className: "search-results__error"
  }, "There was an error loading the results. Please try again later.") : results.length ? _react.default.createElement("div", {
    className: "search-results"
  }, results.map(renderCategory(0))) : _react.default.createElement("div", {
    className: "search-results__no-results"
  }, "No results ", query && _react.default.createElement("span", null, "for \"", query, "\"")), _react.default.createElement("div", {
    className: "search__loading"
  }, " Loading..."))));
};

Search.propTypes = propTypes;
var _default = Search;
exports.default = _default;

},{"../../common/useClickAway.js":1,"../../common/useDebounce.js":2,"../Dropdown/Dropdown.jsx":3,"../Radio/Radio.jsx":4,"../Radio/RadioGroup.jsx":5,"./Pill.jsx":6,"./useApi.js":8,"classnames":"classnames","js-cookie":"js-cookie","prop-types":"prop-types","ramda":"ramda","react":"react"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useApi;

var _react = require("react");

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SEARCH_ENDPOINT = "/api/search/query";

function useApi(variables, initialResults) {
  var url = SEARCH_ENDPOINT + "?" + _queryString.default.stringify(variables);

  var _useState = (0, _react.useState)(initialResults),
      _useState2 = _slicedToArray(_useState, 2),
      results = _useState2[0],
      setResults = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  (0, _react.useEffect)(function () {
    setLoading(true);
    fetch(url).then(function (response) {
      return response.json();
    }).then(function (results) {
      setResults(results);
      setError();
    }).catch(function (error) {
      setError(error);
    }).finally(function () {
      setLoading(false);
    });
  }, [url]);
  return {
    results: results,
    isLoading: isLoading,
    error: error,
    resultsQuery: variables.text
  };
}

},{"query-string":"query-string","react":"react"}],9:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var R = _interopRequireWildcard(require("ramda"));

var _Search = _interopRequireDefault(require("./components/Search/Search.jsx"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener("DOMContentLoaded", function () {
  var mountClass = ".js-search-mount";
  var mountNode = document.querySelector(mountClass);

  if (!mountNode) {
    console.error("".concat(mountClass, " element not found!"));
    return;
  }

  var data = R.compose(JSON.parse, function (node) {
    return node.getAttribute("data-model");
  })(mountNode);

  _reactDom.default.render(_react.default.createElement(_Search.default, data), mountNode);
});

},{"./components/Search/Search.jsx":7,"ramda":"ramda","react":"react","react-dom":"react-dom"}]},{},[9]);
